'use client';

import { useEffect, useState } from 'react';
import GalleryPageClient from './GalleryPageClient';

interface GalleryLabels {
  filterLabels?: Record<string, string>;
  filterHeading?: string;
  emptyText?: string;
}

export default function GalleryClientLoader({ labels }: { labels?: GalleryLabels }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="break-inside-avoid mb-4">
            <div className="rounded-xl overflow-hidden bg-white shadow-sm">
              <div className="aspect-[3/2] bg-[#F0EDE5] animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return <GalleryPageClient labels={labels} />;
}
